// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"8e14f2e2","628":"82d41b1e","975":"df197359"}[chunkId] + ".css";
};